import { applySnapshot, types } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";

export const PieChartModel = types
    .model("PieChartModel", {
        name: customtypes.optional(types.string, ""),
        value: customtypes.optional(types.number, 0),
        color: customtypes.optional(types.string, ""),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
    }));
export type IPieChartModel = typeof PieChartModel.Type;
